import { BaseModel } from './base';

export interface Campagne extends BaseModel {
    name: string;
    path: string;
    title: string;
    description: string;
    imageId: number | null,
    views: number,
    componentRoute: string;
}

export const newCampagne: Campagne = {
    id: 0,
    name: '',
    path: '',
    title: '',
    description: '',
    imageId: null,
    views: 0,
    componentRoute: 'home'
};
